import styled, { css } from 'styled-components'

export const DeliveryAlert = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: start;
    gap: ${theme.space['4']};
    color: ${theme.colors.black500};
    background-color: ${theme.colors.gray100};
    padding: ${theme.space['8']};
    border-radius: ${theme.border.radius['8']};

    & > svg {
      flex-shrink: 0;
    }
  `,
)
